
import { AbstractControl, FormArray, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
export class MaTariffService {
    service_id: number | null = null;
    service_name: string | null = null;
    fields: Fields[] = [];
    constructor(maTariffService?: Partial<MaTariffService>) {
        if (maTariffService) {
            Object.assign(this, maTariffService);
        }
    }

};


export class Fields {
    field_name: string | null = null;
    data_type: string | null = null;
    is_mandatory: string | null = null;
    constructor(vesselFields?: Partial<Fields>) {
        Object.assign(this, vesselFields);
    }
}


const atLeastOneFieldRequiredValidator = (control: AbstractControl): ValidationErrors | null => {
    const fieldsArray = control as FormArray;
    //  At least one field must be present
    if (fieldsArray.length === 0) {
        return { atLeastOneFieldRequired: true };
    }
    return null;
};

const formatColumnName = (input: string): string => {
    if (!input) return '';
    return input
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '_');
};

const fieldKeyResolver = (field: string): string => {
    const normalized = field.trim().toLowerCase();

    switch (normalized) {
        case 'country':
            return 'country_name';
        case 'port':
            return 'port_name';
        default:
            return formatColumnName(field);
    }
}
// method to validate the range
const rangeValidator: ValidatorFn = (formArray: AbstractControl): ValidationErrors | null => {
    if (!formArray || !(formArray instanceof FormArray)) return null;
    let minValue: number | null = null;
    let maxValue: number | null = null;

    formArray.controls.forEach(control => {
        const { field_name, value } = control.value;
        const lowerField = field_name?.toLowerCase()?.trim();
        if (lowerField === 'min range') {
            minValue = value !== '' && value !== null ? Number(value) : null;
        } else if (lowerField === 'max range') {
            maxValue = value !== '' && value !== null ? Number(value) : null;
        }
    });

    if (minValue !== null && maxValue !== null && maxValue <= minValue) {
        return { rangeInvalid: true };
    }

    return null;
};



export { atLeastOneFieldRequiredValidator, formatColumnName, fieldKeyResolver, rangeValidator }